import React from 'react';
import { Role } from '../../../types/permissions';
import RoleItem from './RoleItem';

interface RoleListProps {
  roles: Role[];
  onDeleteRole: (roleId: number) => void;
}

const RoleList: React.FC<RoleListProps> = ({ roles, onDeleteRole }) => {
  return (
    <div className="border rounded-lg p-4">
      <h3 className="font-semibold mb-4 text-lg">Roles Existentes</h3>
      <div className="space-y-3 max-h-[500px] overflow-y-auto">
        {roles.map(role => (
          <RoleItem
            key={role.id}
            role={role}
            onDelete={onDeleteRole}
          />
        ))}
      </div>
    </div>
  );
};

export default RoleList;
